import { Route, Routes } from 'react-router-dom';
import {
  AITimeDefaults,
  ActiveSessionsPage,
  ApiAccessPage,
  AuditLog,
  BackupExportPage,
  BrandingConfig,
  BusinessHoursPage,
  CommunicationsHub,
  ExchangeRunnerPage,
  HolidayCalendar,
  NetworkAccessControl,
  PersonalProfilePage,
  RetentionPage,
  SettingsAIPage,
  SettingsGeneralPage,
  SettingsIntegrationsPage,
  SettingsPlatformPage,
  SettingsStaffPage,
  SettingsVaultPage,
  TenantConsent,
  TicketAttentionPolicyPage,
  TicketWorkflows,
  TrustedDevicesPage,
  Webhooks,
  WorkspaceDetailsPage,
} from '@/app/administration/routes/lazyPages';
import {
  SwitchboardPage,
} from '@/app/navigation/routes/lazyPages';
import {
  ProcurementSettings,
} from '@/capabilities/procurement/public/routes/lazyPages';
import { OrgChart } from '@/capabilities/customer-lifecycle/routes';
import { destinationCapabilityRouteElements } from '@/app/navigation/routes/capabilities/destinationCapabilityRegistry';

export function SwitchboardRoutes() {
  return (
    <Routes>
      <Route index element={<SwitchboardPage />} />
      <Route path="profile" element={<PersonalProfilePage />} />
      <Route path="profile/trusted-devices" element={<TrustedDevicesPage />} />
      <Route path="profile/active-sessions" element={<ActiveSessionsPage />} />
      <Route path="configure" element={<SwitchboardPage />} />
      <Route path="configure/general" element={<SettingsGeneralPage />} />
      <Route path="configure/workspace-details" element={<WorkspaceDetailsPage />} />
      <Route path="configure/api-access" element={<ApiAccessPage />} />
      <Route path="configure/ticket-attention" element={<TicketAttentionPolicyPage />} />
      <Route path="configure/branding" element={<BrandingConfig />} />
      <Route path="configure/organization" element={<OrgChart />} />
      <Route path="configure/integrations" element={<SettingsIntegrationsPage />} />
      <Route path="configure/integrations/webhooks" element={<Webhooks />} />
      <Route path="configure/integrations/procurement" element={<ProcurementSettings />} />
      <Route path="configure/tenant-consent" element={<TenantConsent />} />
      <Route path="configure/vault" element={<SettingsVaultPage />} />
      <Route path="configure/staff" element={<SettingsStaffPage />} />
      <Route path="configure/platform" element={<SettingsPlatformPage />} />
      <Route path="configure/ai" element={<SettingsAIPage />} />
      <Route path="configure/network-access" element={<NetworkAccessControl />} />
      <Route path="configure/communications" element={<CommunicationsHub />} />
      <Route path="configure/business-hours" element={<BusinessHoursPage />} />
      <Route path="configure/holidays" element={<HolidayCalendar />} />
      <Route path="configure/retention" element={<RetentionPage />} />
      <Route path="configure/backup-export" element={<BackupExportPage />} />
      <Route path="configure/exchange-runner" element={<ExchangeRunnerPage />} />
      <Route path="configure/ai-time-defaults" element={<AITimeDefaults />} />
      <Route path="configure/ticket-workflows" element={<TicketWorkflows />} />
      <Route path="configure/audit-log" element={<AuditLog />} />
      {destinationCapabilityRouteElements('switchboard')}
    </Routes>
  );
}
